"use client";
import React from "react";
import { ImageGridOptionsType } from "@/types/ModuleOptionsType";
import ImageGridCard from "./ImageGridCard";
import {
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
import buttonStyles from "../../components/Button/Button.module.scss";
import { Breakpoint } from "@aleksundshantu/aunds-utils-react/layout";
import { ImageGridType } from "./ImageGrid.server";
import { FadeInUp } from "@/components/Animation";

interface ImageGridProps {
  data: ImageGridType;
  imageGridOptions: {
    box: ImageGridOptionsType["box"];
    button_type: ImageGridOptionsType["button_type"];
    show_extended_link: ImageGridOptionsType["show_extended_link"];
    media_format: ImageGridOptionsType["media_format"];
    grid_options: {
      text_align_class: ImageGridOptionsType["grid_options"]["text_align_class"];
      gradient_image_grid?: ImageGridOptionsType["grid_options"]["gradient_image_grid"];
      text_color?: ImageGridOptionsType["grid_options"]["text_color"];
    };
  };
  cardItemWidth: Record<Breakpoint, string>;
  cardHeadlineLevel: number;
}

const ImageGridModuleClient = ({
  data,
  imageGridOptions,
  cardItemWidth,
  cardHeadlineLevel,
}: ImageGridProps) => {
  const { posts_per_page } = data.layout;

  const {
    button_type,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_extended_link,
    media_format,
    grid_options: { text_align_class, gradient_image_grid, text_color },
  } = imageGridOptions;

  const { elements, type, grid_type } = data.image_grid;

  return (
    <Grid
      postsPerPage={posts_per_page}
      fetchItems={() => {
        return {
          posts: elements ? elements : [],
          totalPosts: elements ? elements.length : 0,
        };
      }}
      showAllPages
    >
      {(elements) => {
        return (
          <FadeInUp>
            <GridContent gap="2rem">
              {elements.map((element, key) => {
                return (
                  <GridItem itemWidth={cardItemWidth} key={key}>
                    <ImageGridCard
                      buttonType={button_type}
                      type={type}
                      element={element}
                      gridType={grid_type}
                      textAlignClass={text_align_class}
                      showExtendedLink={show_extended_link}
                      mediaFormat={media_format}
                      showBorderRadius={show_border_radius}
                      showBoxShadow={show_box_shadow}
                      showBox={show_card_box}
                      textColor={text_color}
                      overlayStyle={
                        gradient_image_grid
                          ? { background: gradient_image_grid }
                          : undefined
                      }
                      heading_level={cardHeadlineLevel}
                    />
                  </GridItem>
                );
              })}
            </GridContent>
            <GridLoadMore
              grid_navigation="only-load-more"
              buttonStyles={buttonStyles}
              iconPosition="left"
            />
          </FadeInUp>
        );
      }}
    </Grid>
  );
};

export default ImageGridModuleClient;
